export const LIMIT = 10;
export const ENTER_KEY = 'Enter';

export const PRIMARY_COLOR = '#23756b';
